import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { zFiltersArray } from 'helpers/router';

// The other PeopleTable filter params (advisor_id, tier, …) are still
// normalized by the `/_private` relic schema; `invoice_status`, `type` and
// `pathway` are only used here, so they live at this route per the migration
// noted in _private/route.tsx.
const peopleSearchSchema = z.object({
  invoice_status: zFiltersArray(),
  pathway: zFiltersArray(),
  type: zFiltersArray(),
});

export const Route = createFileRoute('/_private/_route/_internal/people/')({
  validateSearch: peopleSearchSchema,
});
